import React, { useContext } from "react";
import { Navigate, useLocation } from "react-router";

import { AuthContext } from "../../../Context/AuthContext";
import { currentDateObject, getDateformat, getDateformatWise } from "../../../Utils/EqupTimezone";
import { hasAffiliate } from "../../../Utils/utils";

const BILLING_PERMISSION = "account_billing:access";
const BLOCKED_PAYMENT_STATUSES = [
  "failed",
  "past_due",
  "unpaid",
  "canceled",
];

export const SubscriptionAccessGuard = ({ children }) => {
  const { pathname } = useLocation();
  const { userData } = useContext(AuthContext);
  const planData = userData?.authData?.subscription;
  const currentTeam = userData?.authData?.currentTeam;
  const roleType = String(userData?.authData?.role?.role_type || "").toLowerCase();
  const permissions = userData?.authData?.currentUserPermission || [];
  const hasResolvedMembership =
    Boolean(currentTeam?.id) &&
    Array.isArray(userData?.authData?.currentUserPermission);
  const hasAccountBillingAccess = permissions.some(
    (permission) => permission?.name === BILLING_PERMISSION
  );
  const canManageBilling =
    roleType === "owner" ||
    (roleType === "admin" && hasAccountBillingAccess);

  const checkIfPlanExpired = (plan) => {
    const currentDate = getDateformatWise(
      currentDateObject().utc(),
      "YYYY-MM-DD HH:mm:ss"
    );

    const planExpireDate = plan.trial_expiry_date
      ? plan.trial_expiry_date
      : plan.end_at;

    if (!planExpireDate) return false;

    const endDate = getDateformat(planExpireDate).utc();
    return endDate < currentDate;
  };

  const paymentStatus = String(planData?.payment_status || "").toLowerCase();
  const isUnavailable =
    userData?.authenticated &&
    hasResolvedMembership &&
    !hasAffiliate(userData) &&
    (!planData ||
      planData.status === false ||
      checkIfPlanExpired(planData) ||
      BLOCKED_PAYMENT_STATUSES.includes(paymentStatus));

  if (!isUnavailable) {
    if (pathname === "/subscription-unavailable") {
      return <Navigate to="/dashboard" replace />;
    }

    return children;
  }

  if (pathname === "/subscription-unavailable") return children;

  if (canManageBilling) {
    if (pathname === "/settings/accounts-and-billing") return children;
    return <Navigate to="/settings/accounts-and-billing" replace />;
  }

  return <Navigate to="/subscription-unavailable" replace />;
};
